import { render, staticRenderFns } from "./couponUseRecord.vue?vue&type=template&id=3c336574&scoped=true"
import script from "./couponUseRecord.vue?vue&type=script&lang=js"
export * from "./couponUseRecord.vue?vue&type=script&lang=js"
import style0 from "./couponUseRecord.vue?vue&type=style&index=0&id=3c336574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c336574",
  null
  
)

export default component.exports